export default __webpack_public_path__ + "static/media/polk_p_mythical.6150db44.png";